import React from 'react';
import { EMERGENCY_STAGES, STAGE_LABELS, STAGE_COLORS, timeSince } from './constants';
import { Siren, Clock, AlertTriangle, Phone } from 'lucide-react';

export default function EmergencyPanel({ emergencies, onOpen }) {
  if (!emergencies.length) {
    return (
      <div className="flex items-center justify-center h-48 text-slate-500 border border-dashed border-red-500/20 rounded-lg" data-testid="emergency-empty">
        <div className="text-center"><Siren className="w-10 h-10 mx-auto mb-2 opacity-30 text-red-400" /><p>No emergency requests</p></div>
      </div>
    );
  }
  const sorted = [...emergencies].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  return (
    <div className="space-y-3" data-testid="emergency-list">
      {sorted.map(em => {
        const overdue = !['completed', 'closed'].includes(em.status) && (Date.now() - new Date(em.created_at).getTime()) > 24 * 3600000;
        return (
          <div key={em.id} onClick={() => onOpen(em.id)} data-testid={`emergency-list-card-${em.id}`}
            className={`bg-red-950/20 border rounded-lg p-4 cursor-pointer hover:border-red-400/60 transition-colors ${overdue ? 'border-red-500' : 'border-red-500/30'}`}>
            <div className="flex items-center justify-between gap-3 flex-wrap">
              <div className="flex items-center gap-3">
                <Siren className="w-5 h-5 text-red-400" />
                <div>
                  <div className="text-white font-semibold">{em.name}</div>
                  <div className="text-red-300/90 text-xs flex items-center gap-1.5"><AlertTriangle className="w-3 h-3" />{em.emergency_category}</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className={`text-xs flex items-center gap-1 ${overdue ? 'text-red-400 font-bold' : 'text-amber-300'}`}>
                  <Clock className="w-3.5 h-3.5" />{timeSince(em.created_at)}{overdue ? ' ⚠ OVERDUE' : ''}
                </span>
                <a href={`tel:${em.phone}`} onClick={e => e.stopPropagation()} className="text-slate-300 hover:text-white flex items-center gap-1 text-xs"><Phone className="w-3.5 h-3.5" />{em.phone}</a>
                <span className={`text-xs px-2 py-0.5 rounded-full border ${STAGE_COLORS[em.status] || ''}`}>{STAGE_LABELS[em.status] || em.status}</span>
              </div>
            </div>
            {em.description && <p className="text-slate-400 text-xs mt-2 truncate">{em.description}</p>}
          </div>
        );
      })}
    </div>
  );
}
